import React from 'react';

import Banner from '../Banner';

import { Clear } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { Typography, IconButton } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import Warning from '@material-ui/icons/Warning';
import { FormattedMessage } from 'react-intl';
import { withNavigation } from '../../actions/navigation';

const styles = theme => ({
  banner: {
    backgroundColor:'#ff574a', 
    backgroundSize: 'cover', 
    height: 64,
  },
  defaultText: {
    color: '#FFFFFF',
    fontWeight: 400,
    fontSize: 16,
    position: 'relative',
    top: -3,
  },
  button: {
    color: 'white',
    marginRight: 8,
  },
  warningIcon: {
    top: 6,
    position: 'relative',
    marginLeft: 16,
    marginRight: 16,
  },
  link: {
    paddingLeft: 16,
    color: 'white',
    fontWeight: 'bold'
  }
});

class WarningBanner extends React.Component {
  
  getMessage(alert, user) {
    if(alert.id === 'MAX_LICENCES_COUNT_REACH_ON_SUBSCRIPTION_WITH_DOMAINS') {
      return <FormattedMessage id='subscription.warning.max.licences.reached' values={{ domain: user.principalDomain }} /> 
    }
    return alert.message;
  }

  render() {
    const {
      dismiss,
      user,
      subscriptionId,
      navigateToSubscriptionEdit,
      alert,
      classes,
    } = this.props;

    const message = this.getMessage(alert, user);

    return (
      <Banner
        paperStyle={classes.banner}
        actions={[
          <IconButton
            key={alert.id}
            className={classes.button}
            aria-label="dismiss alert"
            onClick={dismiss}
          >
            <Clear />
          </IconButton>
        ]}
      >
        <Typography className={classes.defaultText} align='left'>
          <Warning className={classes.warningIcon} nativeColor='white' />
          {message}
          <Link
            component="button"
            variant="body2"
            className={classes.link}
            onClick={() => navigateToSubscriptionEdit(subscriptionId)}
          >
            <FormattedMessage id='subscription.warning.link' />
          </Link>
        </Typography>
      </Banner>
    )
  }
}

export default withStyles(styles)(withNavigation(WarningBanner));


// WEBPACK FOOTER //
// ./src/components/subscriptions/WarningBanner.js